var map = {
	"./Frame 3481.png": 427,
	"./LOGO@2x.png": 428,
	"./arrow-down-blue.svg": 429,
	"./arrow-down-grey.svg": 430,
	"./arrow-right-white.png": 431,
	"./arrow-right.svg": 432,
	"./bg.jpg": 433,
	"./bg.png": 168,
	"./binance-logo.png": 169,
	"./binance.svg": 434,
	"./blue-loader.svg": 170,
	"./circle-grey.svg": 435,
	"./circle.svg": 436,
	"./coinbaseWalletIcon.svg": 122,
	"./dropdown-blue.svg": 437,
	"./dropdown.svg": 438,
	"./dropup-blue.svg": 439,
	"./ethereum-logo.png": 440,
	"./fortmaticIcon.png": 123,
	"./image_flip.png": 441,
	"./link.svg": 442,
	"./logob.png": 164,
	"./logow.png": 163,
	"./magnifying-glass.svg": 443,
	"./menu.svg": 444,
	"./metamask.png": 171,
	"./plus-blue.svg": 445,
	"./plus-grey.svg": 446,
	"./portisIcon.png": 124,
	"./question-mark.svg": 447,
	"./question.svg": 448,
	"./spinner.svg": 449,
	"./trustWallet.png": 450,
	"./walletConnectIcon.svg": 125,
	"./wbnb.png": 451,
	"./x.svg": 452
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 154;